import React from 'react';
import OverviewTable from 'components/Table/Table';
import { TableColumnInterface } from 'components/Table/table.types';
import { UserGroup } from '@restore/services-lib';
import { useUsersContext } from 'context/users.context';
import { Tag } from 'components/Tag/Tag';
import { Link } from 'react-router-dom';
import CreateUserGroup from 'pages/UserGroups/CreateUserGroup';
import EmptyData from 'components/Messages/EmptyData/EmptyData';
import PermissionCheck from 'components/Abilities/PermissionCheck';
import { truncateText } from 'utils/formatting';

const UserGroupsTable = (): JSX.Element => {
  const { userGroups } = useUsersContext();

  const tableCols: TableColumnInterface<UserGroup>[] = [
    {
      label: 'Name',
      value: (userGroup) => (
        <Link to={`/groups/${userGroup.id}`}>
          {<Tag color={userGroup.displayColour} text={truncateText(userGroup.name, 30)} />}
        </Link>
      ),
      sortBy: 'name',
    },
    {
      label: '',
      align: 'right',
      value: (userGroup) => (
        <PermissionCheck permission={{ action: 'update', subject: 'UserGroup' }}>
          <Link to={`/groups/${userGroup.id}`}>Edit</Link>
        </PermissionCheck>
      ),
    },
  ];

  return (
    <OverviewTable
      data={userGroups}
      columns={tableCols}
      noDataMessageOverride={<EmptyData dataType='Permission Group' action={<CreateUserGroup />} />}
    />
  );
};

export default UserGroupsTable;
